<template>

	<div class="bg-container page">
		<div class="dong_box">
			<div class="dong_i"></div>
		</div>
		<div class="bg-wrapper">
			<div class="register">
				<van-nav-bar class="nav-bar">
					<template #left>
						<div style="display: flex;align-items: center;" @click="back()">
							<img src="/img/newLogin/download.png" style="width: 20px;height: 15px;" /> <span
								style="font-size: 14px;color: #f3c7a2;margin-left: 10px;">{{ $t("q0") }}</span>
						</div>

					</template>
				</van-nav-bar>
				<div class="wrapper">
					<div class="content-tab">
						<img class="login-logo" src="/img/newLogin/newlog.png" style="width: 40%;">
						<div class="tab-title">
							<span class="active">{{$t("auth.register")}}</span>
						</div>
						<div class="tab-transform">
							<p class="active" style="left: 0px;"></p>
						</div>
					</div>
					<!--      <div class="title">{{$t("auth.register")}}</div> -->
					<div class="loginForm">
						<van-field v-model="username" clearable input-align="center" class="input"
							:placeholder="$t('auth.username_place')">
							<template slot="left-icon">
								<img class="login-logo" src="/img/newLogin/21.png">
							</template>
						</van-field>
						<div class="sm_tit">
							{{ $t("q2") }}
						</div>
						<van-field v-model="password" :type="passwordType" input-align="center" class="input"
							:placeholder="$t('auth.pwd_place')">
							<template slot="left-icon">
								<img class="login-logo" src="/img/newLogin/22.png">
							</template>
							<template slot="right-icon">
								<van-icon :name=" passwordType === 'password' ? 'closed-eye':'eye-o'"
									@click="switchPasswordType" />
							</template>
						</van-field>
						<div class="sm_tit">
							{{ $t("q3") }}
						</div>
						<!-- <div class="yam_box">
              <van-field
                v-model="yzm"
                input-align="center"
                class="input"
                :placeholder="'请输入验证码'">
            </van-field>
              <div class="ym_x">
                <Captcha ref="Captcha" />
              </div>
              
            </div>

            <div class="sm_tit">
              4请输入数字字母验证码
            </div> -->

						<van-field v-model="code" clearable input-align="center" class="input"
							:placeholder="$t('auth.invite_code_place')" >
							<template slot="left-icon">
								<img class="login-logo" src="/img/newLogin/21.png">
							</template>
							</van-field>
						<!-- <div class="agreement">
              <van-checkbox v-model="checked" />
              <span class="agreement-text">{{$t("auth.agreement_place")}}</span>
            </div> -->

						<div class="sm_tit">
							{{ $t("q4") }}
						</div>
						<!-- <div class="agreement">
							<van-checkbox v-model="checked" />
							<span class="agreement-text">私は18 歳以上であり、上記の規約に同意する場合は私は同意しますをクリックしてください 《登録条件》</span>
						</div> -->
						<div class="Register-clause">
							<img src="/img/newLogin/20.png" style="width:15px">
							<div style="font-size: 13px;    margin-left: 10px;">

								如果我已年滿18歲並同意以上條款，請點選「我同意」。
							</div>
						</div>
						<van-button class="login-btn" type="primary" size="normal"
							@click="doRegister()">{{$t("auth.register")}}</van-button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	// import Captcha from "./Captcha.vue"
	export default {
		model: {
			prop: 'inputValue',
			event: 'input'
		},
		components: {
			// Captcha
		},
		props: {
			/**
			 * 当前输入的值
			 */
			inputValue: {
				type: String,
				default: ''
			}
		},
		data() {
			return {
				captchaValue: "",
				yzm: "",
				checked: true,
				username: '',
				code: '',
				lang: 'en_us',
				password: this.inputValue,
				passwordType: 'password',
			};
		},
		mounted() {
			this.lang = localStorage.getItem("lang") || 'es_spa';
		},
		methods: {
			switchPasswordType() {
				this.passwordType = this.passwordType === 'password' ? 'text' : 'password'
			},
			back() {
				return window.history.back();
			},
			doRegister() {
				if (this.username === "" || this.username === null || this.username === undefined) {
					this.$toast.fail(this.$t("auth.username_place"));
					return false;
				}
				if (this.password === "" || this.password === null || this.password === undefined) {
					this.$toast.fail(this.$t("auth.pwd_place"));
					return false;
				}

				// let cc = this.$refs.Captcha.getYam();
				// if(cc.trim().toLowerCase() != this.yzm.trim().toLowerCase()){
				//   this.$toast.fail('4桁の英数字の認証コードをご入力ください');
				//   return false
				// }

				if (this.code === "" || this.code === null || this.code === undefined) {
					this.$toast.fail(this.$t("auth.invite_code_place"));
					return false;
				}
				if (!this.checked) {
					this.$toast.fail(this.$t("auth.agreement"));
					return false;
				}
				this.$http({
					method: 'post',
					data: {
						username: this.username,
						password: this.password,
						code: this.code,
						lang: this.lang
					},
					url: 'member_register'
				}).then(res => {
					if (res.code === 200) {
						this.$toast.success(res.msg);
						localStorage.setItem('token', res.data)
						this.$router.push("Mine")
					} else {
						this.$toast.fail(res.msg);
					}
				})
			}
		},
		created() {
			if (localStorage.getItem('token')) {
				return window.history.back();
			}
		}
	};
</script>

<style lang='less' scoped>
	@import "../../assets/css/base.css";

	.Register-clause {
		display: -webkit-box;
		display: -ms-flexbox;
		display: flex;
		-webkit-box-orient: horizontal;
		-webkit-box-direction: normal;
		-ms-flex-direction: row;
		flex-direction: row;
		-webkit-box-align: center;
		-ms-flex-align: center;
		align-items: center;
		-webkit-box-pack: center;
		-ms-flex-pack: center;
		justify-content: center;
		font-size: 0.28rem;
		color: #e1e1e1;
		margin: .35rem 0;
	}

	.tab-transform {
		position: relative;
		height: 2px;
		width: 8rem;
		background: #ff4d67;
	}

	.tab-title .active {
		font-size: 30px;
		color: #ff4d67;
	}

	.tab-title {
		font-size: 0.32rem;
		color: #d7d7d7;
		/* width: 4rem; */
		display: -webkit-box;
		display: -ms-flexbox;
		display: flex;
		-webkit-box-orient: horizontal;
		-webkit-box-direction: normal;
		-ms-flex-direction: row;
		flex-direction: row;
		-webkit-box-align: center;
		-ms-flex-align: center;
		align-items: center;
		-webkit-box-pack: justify;
		-ms-flex-pack: justify;
		justify-content: space-between;
		margin-bottom: .12rem;
	}


	.content-tab {
		margin: 0.5rem 0 0 0 !important;
		display: -webkit-box;
		display: -ms-flexbox;
		display: flex;
		-webkit-box-orient: vertical;
		-webkit-box-direction: normal;
		-ms-flex-direction: column;
		flex-direction: column;
		-webkit-box-align: center;
		-ms-flex-align: center;
		align-items: center;
		-webkit-box-pack: center;
		-ms-flex-pack: center;
		justify-content: center;
	}




	.yam_box {
		display: flex;
		justify-content: space-between;
		align-items: center;

		.ym_x {
			margin-left: 20px;
			padding-top: 40px;
		}
	}

	.sm_tit {
		font-size: 24px;
		color: #ccc;
		padding-left: 36px;
		margin: 10px 0 20px;
	}

	.sm_tit_sk {
		font-size: 28px;
		color: #fff;
	}

	.dong_box {
		height: 100%;

		@keyframes bg-data-v-8175861c {

			0%,
			100% {
				background-position-x: 0;
			}

			50% {
				background-position-x: 100%;
			}
		}

		.dong_i {
			height: 100%;
			height: 100%;
			width: auto;
			animation: bg-data-v-8175861c 20s linear infinite;
			background: url(/img/newLogin/loginn.jpg) no-repeat 0 0;
			background-size: auto 100%;
			height: 100%;

		}
	}

	.register {
		height: 100%;
	}

	.bg-container .bg-wrapper .register .nav-bar {
		background: 0 0
	}

	.bg-container .bg-wrapper {
		background: #00000082 no-repeat 0 0;
		background-size: 100% 100%;
	}

	.register .wrapper {
		overflow-y: auto;
		-webkit-overflow-scrolling: touch;
	}

	.logo-container {
		margin: 0 auto;
		width: 45%;
	}

	.logo-container .logo-wrapper {
		position: relative;
		padding-bottom: 62.5%;
	}

	.logo-container .logo-wrapper .logo-img {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		-o-object-fit: contain;
		object-fit: contain;
	}

	.register .wrapper .title {
		line-height: 100px;
		text-align: center;
		font-size: 45px;
		font-weight: 700;
		color: #fff;
		letter-spacing: 5px;
	}

	.register .wrapper .loginForm {
		padding-left: 60px;
		padding-right: 60px;
		padding-top: 0;
		padding-bottom: 0;
	}

	.register .wrapper .loginForm .input {
		padding: 26px 20px;
		margin-top: 40px;
		border-radius: 10px;
		text-align: center;
		// line-height: 80px;
		font-size: 30px;


		width: 100% !important;
		height: 100%;
		box-sizing: border-box;

		/* 	background: linear-gradient(120deg, #212121, #313131); */
		border: 2px solid #766350;
		color: #e6b98a;
	}

	::v-deep .van-cell::after {
		display: none;
	}

	::v-deep .van-field__right-icon .van-icon {
		font-size: 50px;
	}

	::v-deep .van-icon {
		font-size: 50px;
	}

	::v-deep .van-field__control {
		color: #e6b98a;
	}

	.register .wrapper .loginForm .reset-text {
		margin: 30px 15px;
		display: flex;
		align-items: center;
		justify-content: flex-end;
	}

	.register .wrapper .loginForm .reset-text span {
		color: #fff;
		font-size: 25px;
		font-weight: 500;
		line-height: 15px;
	}

	.register .wrapper .loginForm .register-text {
		margin: 10px 0;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.register .wrapper .loginForm .register-text span {
		color: #fff;
		font-size: 25px;
		font-weight: 500;
		line-height: 20px;
	}

	.register .wrapper .loginForm .login-btn {
		margin-top: 85px;
		width: 100%;
		height: 80px;
		border-radius: 50px;
		color: #68302c;
		background: linear-gradient(to right, #ff7a8d 0%, #ff4d67 100%);
		font-size: 30px;
		font-weight: bolder;
		border: none;
	}

	.register .wrapper .loginForm .agreement {
		margin-top: 30px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.register .wrapper .loginForm .agreement .agreement-text {
		margin-left: 10px;
		font-size: 25px;
		color: #fff;
		font-weight: 500;
		line-height: 30px;
	}

	::v-deep .agreement .van-icon {
		font-size: 30px;
	}

	::v-deep .agreement .van-checkbox__icon {
		font-size: 38px;
	}

	::v-deep .agreement .van-checkbox__icon--checked .van-icon {
		color: #fff;
		border-color: rgb(126, 86, 120);
		background-color: rgb(126, 86, 120);
	}
</style>